<template>
  <cart-footer-template
    :should-display-total-cost="shouldDisplayTotalCost"
    :can-display-delivery-cost="canDisplayDeliveryCost"
    :payment-info="paymentInfo"
    :should-show-v-a-t="shouldShowVAT"
    :custom-fee="customFee"
    :delivery-cost="cartFooterDeliveryCost"
    :delivery-cost-classes="deliveryCostClasses"
    :has-pay-pal-pay-later-option="hasPaypalPayLaterOption"
    :order-total-cost="orderTotalCost"
    :should-show-promo-code-section="shouldShowPromoCodeSection"
    :country="deliveryCountry"
    :show-u-s-a-tax-warning="showUSATaxWarning"
  />
</template>

<script>
import { mapGetters, mapState } from 'vuex';

import CartFooterTemplate from '@/components/cart/CartFooterTemplate.vue';

import { getPriceValue, Price } from '@/models/core/values';

import { types } from '@/store/types';
import { COUNTRY_ISO } from '@/constants/countries';

const SWIZZ_TAX_FREE_PRICE = 65;

export default {
  name: 'CartFooter',
  components: { CartFooterTemplate },
  props: {
    shouldDisplayTotalCost: {
      type: Boolean,
      default: false
    },
    canDisplayDeliveryCost: {
      type: Boolean,
      default: false
    },
    showUSATaxWarning: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState({
      deliveryData: types.state.DELIVERY_DATA,
      promoCodeData: types.state.PROMO_CODE_DATA,
      deliveryType: types.state.DELIVERY_TYPE
    }),
    ...mapGetters({
      cartPrice: types.getters.CART_PRICE,
      hasFreeDelivery: types.getters.HAS_FREE_DELIVERY,
      deliveryCost: types.getters.DELIVERY_COST,
      deliveryCountry: types.getters.DELIVERY_COUNTRY,
      totalCostWithoutDiscount: types.getters.TOTAL_COST_WITHOUT_DISCOUNT,
      totalCost: types.getters.TOTAL_ORDER_COST,
      getShippingPaymentInfo: types.getters.GET_SHIPPING_PAYMENT_INFO,
      getIfCustomFeeWarningsMustBeShown: types.getters.GET_IF_CUSTOM_FEE_WARNING_MUST_BE_SHOWN,
      hasPaypalPayLaterOption: types.getters.HAS_PAYPAL_PAY_LATER_OPTION,
      currency: types.getters.CURRENCY
    }),
    paymentInfo() {
      return this.getShippingPaymentInfo({
        shouldDisplayTotalCost: this.shouldDisplayTotalCost
      });
    },
    orderTotalCost() {
      return this.paymentInfo.totalCost;
    },
    hasGreatBritainDelivery() {
      return this.deliveryCountry.toLowerCase() === COUNTRY_ISO.GREAT_BRITAIN.toLowerCase();
    },
    shouldShowCustomsFeeWarning() {
      return this.getIfCustomFeeWarningsMustBeShown({
        shouldDisplayTotalCost: this.shouldDisplayTotalCost
      });
    },
    hasSwitzerlandFreeCustomFee() {
      return (
        this.deliveryCountry === COUNTRY_ISO.SWITZERLAND.toLowerCase() &&
        getPriceValue(this.totalCost) < SWIZZ_TAX_FREE_PRICE
      );
    },
    shouldShowVAT() {
      return this.hasGreatBritainDelivery && this.shouldShowCustomsFeeWarning;
    },
    customFee() {
      if (!this.deliveryData || !this.shouldShowCustomsFeeWarning) {
        return null;
      }

      if (this.hasSwitzerlandFreeCustomFee) {
        return Price(0, this.currency);
      }

      const { classicCustomsClearanceFee, expressCustomsClearanceFee } = this.deliveryData;

      const customFee =
        this.deliveryType === 'classic' ? classicCustomsClearanceFee : expressCustomsClearanceFee;

      return Price(customFee, this.currency);
    },
    cartFooterDeliveryCost() {
      if (this.hasFreeDelivery) {
        return Price(0, this.currency);
      }

      return this.canDisplayDeliveryCost ? this.deliveryCost : null;
    },
    deliveryCostClasses() {
      return {
        section__hint: !this.hasFreeDelivery && !this.canDisplayDeliveryCost
      };
    },
    shouldShowPromoCodeSection() {
      return !this.shouldDisplayTotalCost || (this.shouldDisplayTotalCost && !!this.promoCodeData);
    }
  }
};
</script>
